<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="500px">
    <v-card id="printArea">
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
            <span class="px-3">{{ $t('View Product Type Information') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3">
        <v-layout column>
          <v-layout row wrap>
            <v-flex xs12 sm9 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <v-flex xs12 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Product Type Name') }}
                  </div>
                  <strong>{{ productTypeInfo.product_type_name || '-' }}</strong>
                </v-flex>

                <v-flex xs12 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Product Type Description') }}
                  </div>
                  <strong v-html="lnToBr(productTypeInfo.product_type_description) || '-'" />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Close') }}</v-btn>
          <!-- <v-btn color="primary" @click="printMe()">
              <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">
                print
              </v-icon>
              {{ $t('Print') }}
          </v-btn>-->
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'view-component',

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      productTypeInfo: 'productTypes/getProductTypeInfo'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    lnToBr(str) {
      return helpers.newLineToBreakLine(str)
    },

    printMe() {
      helpers.doPrinting()
    }
  }
}
</script>

<style scoped />
